import { store } from "../state/StateStore";
import { XRewardConfig } from "../data/XRewardConfig";
import { XShareService } from "../services/XShareService";

export class XRewardSystem {
  /** Execute share and apply reward */
  shareAndReward(): boolean {
    const state = store.get();

    if (state.sharesUsed >= XRewardConfig.maxSharesPerSession) {
      return false; // Already shared this session
    }

    // Open X share
    XShareService.share(state.score);

    // Apply bonus
    store.set({
      score: state.score + XRewardConfig.shareBonus,
      sharesUsed: state.sharesUsed + 1,
    });

    return true;
  }

  /** Check if share reward is available */
  isRewardAvailable(): boolean {
    return store.get().sharesUsed < XRewardConfig.maxSharesPerSession;
  }
}
